import {
    SET_ADD_NEW_PARTNER_OPENED,
    SET_ACTIVE_PARTNER,
    SET_PARTNERS,
    SET_IS_HISTORY_OPENED,
    Actions,
    State,
} from "./partners-types";

const initialState = {
    partners: [],
    activePartner: {
        name: "",
        id: "",
    },
    isAddNewPartnerOpened: false,
    isHistoryOpened: false,
};

const partnersReducer = (
    state: State = initialState,
    action: Actions
): State => {
    switch (action.type) {
        case SET_IS_HISTORY_OPENED: {
            return {
                ...state,
                isHistoryOpened: action.isHistoryOpened,
            };
        }
        case SET_PARTNERS:
            return {
                ...state,
                partners: action.partners,
            };
        case SET_ADD_NEW_PARTNER_OPENED:
            return {
                ...state,
                isAddNewPartnerOpened: action.isAddNewPartnerOpened,
            };
        case SET_ACTIVE_PARTNER:
            return {
                ...state,
                activePartner: { ...action.activePartner },
            };
        default:
            return state;
    }
};

export default partnersReducer;
